import { useEffect, useState } from "react";
import { Download, FileText, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { apiRequest } from "@/lib/queryClient";
import { erroDaApi } from "@/lib/repasse-externo";

export function ComprovanteRepasseButton({ registroId, nome }: { registroId: string; nome: string }) {
  const [aberto, setAberto] = useState(false);
  const [arquivo, setArquivo] = useState<{ url: string; mime: string } | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [tentativa, setTentativa] = useState(0);

  useEffect(() => {
    if (!aberto) return;
    let ativo = true;
    let url: string | undefined;
    setArquivo(null);
    setErro(null);
    apiRequest("GET", `/api/repasses/externo/${registroId}/comprovante`)
      .then((response) => response.blob())
      .then((blob) => {
        if (!ativo) return;
        url = URL.createObjectURL(blob);
        setArquivo({ url, mime: blob.type });
      })
      .catch((error) => { if (ativo) setErro(erroDaApi(error).message); });
    return () => { ativo = false; if (url) URL.revokeObjectURL(url); };
  }, [aberto, registroId, tentativa]);

  return (
    <>
      <Button type="button" size="sm" variant="outline" onClick={() => setAberto(true)} aria-label={`Ver comprovante: ${nome}`}>
        <FileText className="mr-2 h-4 w-4" aria-hidden="true" />Ver comprovante
      </Button>
      <Dialog open={aberto} onOpenChange={setAberto}>
        <DialogContent className="max-h-[90dvh] max-w-3xl overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Comprovante do repasse</DialogTitle>
            <DialogDescription className="break-words">{nome}. Confira o valor e o destinatário no documento.</DialogDescription>
          </DialogHeader>
          {erro ? (
            <div className="space-y-3"><p role="alert" className="text-sm text-destructive">{erro}</p><Button variant="outline" onClick={() => setTentativa((value) => value + 1)}>Tentar novamente</Button></div>
          ) : !arquivo ? (
            <p role="status" className="flex items-center gap-2 text-sm"><RefreshCw className="h-4 w-4 animate-spin" aria-hidden="true" />Carregando comprovante…</p>
          ) : (
            <div className="space-y-4">
              {arquivo.mime === "application/pdf" ? (
                <iframe src={arquivo.url} title={`Comprovante: ${nome}`} sandbox="allow-same-origin" className="h-[55dvh] w-full rounded-md border" />
              ) : (
                <img src={arquivo.url} alt={`Comprovante de repasse: ${nome}`} className="mx-auto max-h-[55dvh] max-w-full object-contain" />
              )}
              <Button asChild variant="outline"><a href={arquivo.url} download={nome}><Download className="mr-2 h-4 w-4" aria-hidden="true" />Baixar comprovante</a></Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
